<script lang="ts">
    import axios from 'axios'

    export let app: string = ''
    export let isEndato: boolean

    let username: string = ''
    let email: string = ''

    let selectedOption: number = 0
    let questions: {id: number; question: string, answer?: string|undefined}[] = []
    let answers: string[] = []

    // Step 1 (Get available reset verification methods)
    let getMethodInProgress: boolean = false
    let getMethodReqCompleted: boolean = false;

    // Step 2 (Request verification code to requested method)
    let verifyInProgress: boolean = false
    let verifyReqCompleted: boolean = false

    let error: string = ''
    let success: string = ''

    let availableVerificationMethods: any[] = []

    let isValid = (isEndato || email.length) && username.length

    const doSubmitPasswordReset = async () => {
        error = ''
        success = ''

        verifyInProgress = true

        let securityAnswers = questions.map(f => { delete f.question; f.answer = answers[questions.indexOf(f)]; return f })

        let response = await axios.post(`/Account/ResetPassword/Process`, {
            source: app,
            username,
            email: !isEndato ? email : username,
            verificationMethod: Number(selectedOption),
            answers: securityAnswers
        })

        if (response.data.successful) {
            success = response.data.message
            verifyInProgress = false
            verifyReqCompleted = true
            setTimeout(() => {
                window.location.href = response.data.location
            }, 1000)
        } else {
            error = response.data.message
            verifyInProgress = false
            verifyReqCompleted = false

        }
    }

    const doGetResetMethods = async () => {
        error = ''
        success = ''

        getMethodInProgress = true
        let response = await axios.post(`/Account/ResetPassword/Process`, {
            source: app,
            username,
            email: !isEndato ? email : '',
        })

        if (response.data.successful) {
            success = response.data.message
            getMethodInProgress = false
            getMethodReqCompleted = true
            availableVerificationMethods = response.data.resetOptions

            let opts = JSON.parse(availableVerificationMethods[3])
            questions = Object.keys(opts).map(f => opts[f])
        } else {
            error = 'An unexpected error occurred processing your request. Please try again later.'
            getMethodInProgress = false
        }
    }

    const getNameFor = (id: number) => {
        switch(id) {
            case 1: return 'Email to ';
            case 2: return 'Text Message to ';
            case 3: return 'Security Questions';
            case 4: return 'Phone Call to ';
        }
    }
</script>

{#if !getMethodReqCompleted}
    <form on:submit|preventDefault|stopPropagation={doGetResetMethods}>
        <div class="container-fluid container-lg min-vh-100 d-flex justify-content-center align-items-center">
            <div class="row m-md-5 no-gutters shadow-lg px-0 responsive-fix">
                <div class="col-lg-6 d-none d-lg-block">
                    <img alt="loginsplash"
                         class="img-fluid"
                         src="https://images.unsplash.com/photo-1537984123158-e59ce0360017?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2370&q=80"
                         style="min-height:100%;"/>
                </div>
                <div class="col-lg-6 p-md-5">
                    <h4>Reset Password</h4>
                    <div class="form-style">
                        {#if success}
                            <div class="form-group row mb-3 mx-1">
                                <div class="alert alert-success">
                                    {@html success}
                                </div>
                            </div>
                        {/if}
                        {#if error}
                            <div class="form-group row mb-3 mx-1">
                                <div class="alert alert-danger">
                                    {@html error}
                                </div>
                            </div>
                        {/if}
                        <div class="form-group row mb-3">
                            <label class="form-label col-3" for="txtUsername">Username</label>
                            <div class="col-9">
                                <input bind:value={username} class="form-control" disabled={getMethodInProgress || getMethodReqCompleted} id="txtUsername"
                                       type="text"/>
                            </div>
                        </div>
                        {#if !isEndato}
                            <div class="form-group row mb-3">
                                <label class="form-label col-3" for="txtEmail">Email</label>
                                <div class="col-9">
                                    <input bind:value={email} class="form-control" disabled={getMethodInProgress || getMethodReqCompleted} id="txtEmail"
                                           type="email"/>
                                </div>
                            </div>
                        {/if}
                        <div class="row">
                            {#if !getMethodReqCompleted}
                                <div class="col">
                                    <button class="btn btn-primary"
                                            type="submit"
                                            class:disabled={getMethodInProgress || (!isEndato && !email) || !username}>{@html (getMethodInProgress ? '<i class="fa-solid fa-spinner fa-spin"></i> Please wait...' : 'Submit')}</button>
                                </div>
                            {/if}
                            <div class="col text-end">
                                <a on:click={(e) => {
                                    e.preventDefault()
                                    
                                    if (dataLayer) { dataLayer.push({'event': 'login_start'}) }
                                    window.location.href = '/Account/Login'
                                }} href="/Account/Login">Back to Login</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
{:else}
    <form on:submit|preventDefault|stopPropagation={doSubmitPasswordReset}>
        <div class="container-fluid container-lg min-vh-100 d-flex justify-content-center align-items-center">
            <div class="row m-md-5 no-gutters shadow-lg px-0 responsive-fix">
                <div class="col-lg-6 d-none d-lg-block">
                    <img alt="loginsplash"
                         class="img-fluid"
                         src="https://images.unsplash.com/photo-1537984123158-e59ce0360017?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2370&q=80"
                         style="min-height:100%;"/>
                </div>
                <div class="col-lg-6 p-md-5">
                    <h4>Choose a Verification Method</h4>
                    <div class="form-style">
                        {#if availableVerificationMethods.length < 1}
                            <div class="row"><div class="alert alert-warning">You have no available password reset verification methods. To reset your password, you must contact customer service.</div></div>
                            <div class="row">
                                <div class="col text-end">
                                    <a on:click={(e) => {
                                            e.preventDefault()
                                            
                                            if (dataLayer) { dataLayer.push({'event': 'login_start'}) }
                                            window.location.href = '/Account/Login'
                                        }} href="/Account/Login">Back to Login</a>
                                </div>
                            </div>
                        {:else}
                            {#if success}
                                <div class="form-group row mb-3 mx-1">
                                    <div class="alert alert-success">
                                        {@html success}
                                    </div>
                                </div>
                            {/if}
                            {#if error}
                                <div class="form-group row mb-3 mx-1">
                                    <div class="alert alert-danger">
                                        {@html error}
                                    </div>
                                </div>
                            {/if}

                            <div class="row">
                                {#each Object.keys(availableVerificationMethods) as option}
                                    <div class="form-check">
                                        <input bind:group={selectedOption} class="form-check-input" type="radio" id={option} value={option} name="resetVerifyOpts">
                                        <label class="form-check-label" for={option}>
                                            {getNameFor(Number(option))}
                                            {#if Number(option) !== 3}
                                                {availableVerificationMethods[option]}
                                            {/if}
                                        </label>
                                    </div>
                                {/each}
                            </div>

                            {#if Number(selectedOption) === 3}
                                {#each JSON.parse(availableVerificationMethods[3]) as question, i}
                                    <div class="form-group row mt-3">
                                        <label class="col-form-label-sm col-12" for="question_{i + 1}">Question {i + 1}: {question.question}</label>
                                        <div class="col-12">
                                            <input class="form-control-sm" id="question_{i + 1}" bind:value={answers[i]} />
                                        </div>
                                    </div>
                                {/each}
                            {/if}

                            <div class="row mt-3">
                                {#if !verifyReqCompleted}
                                    <div class="col">
                                        <button class="btn btn-primary"
                                                type="submit"
                                                class:disabled={verifyInProgress}>{@html (verifyInProgress ? '<i class="fa-solid fa-spinner fa-spin"></i> Please wait...' : 'Submit')}</button>
                                    </div>
                                {/if}
                                <div class="col text-end">
                                    <a on:click={(e) => {
                                        e.preventDefault()
                                        
                                        if (dataLayer) { dataLayer.push({'event': 'login_start'}) }
                                        window.location.href = '/Account/Login'
                                    }} href="/Account/Login">Back to Login</a>
                                </div>
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </form>
{/if}

<style>
    .service-provider-logo {
        margin-top: 1rem;
        margin-left: 1rem;
        display: block;
        width: 220px;
        height: 53px;
        background-image: var(--logo-path);
        background-size: contain;
        background-repeat: no-repeat no-repeat;
    }

    @media (max-width: 768px) {
        .responsive-fix {
            display: block;
            margin: 0;
            padding: 0;
            width: 100vw !important;
            height: 100vh !important;
        }
    }
</style>